import React from 'react';
import {
    formatter, formatterCurrency, BASE_CURRENCY
} from "../../../../utils/common";

const Widget = ({ textColorClass, value, label, isShowSubValue, subValue, isShowDifference, differenceValue }) => {
    textColorClass = textColorClass ? textColorClass : 'text-dark';
    return (
        <div className="col-md-6 col-xl">
            <div className={`widget-rounded-circle card-box summary-card-box`}>
                <div className="text-right">
                    <h6 className="text-truncate card-box-title">{label}</h6>
                    <h5 className={`card-box-value ${textColorClass}`}>{value}</h5>

                    {isShowSubValue ? (                    
                    <h6 className="card-box-sub-value">{subValue}</h6>
                    ) : null}

                    {isShowDifference ? (                    
                    <h6 className="card-box-sub-value text-danger">{differenceValue}</h6>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

const PaymentsTotalSummary = ({ financesSummaryState ,fillterGateway}) => {
    
    const queryParams = new URLSearchParams(window.location.search);
    
    const totalRow = financesSummaryState.paymentsDetailsTableRow;
    const totalSummary = financesSummaryState.paymentsDetailsTotalSummary;
    // const currency = totalSummary && totalSummary.currency ? totalSummary.currency : null;
    const currency = queryParams.get('presentment_currency');

    const isPaypal = fillterGateway?.key?.toLowerCase().includes('paypal') || false;
    const isShopify = fillterGateway?.key?.toLowerCase().includes('shopify_payments') || false;

    const differenceGatewayFees = (totalSummary ? totalSummary.total_gateway_fee : 0) - (totalSummary ? totalSummary.main_total_gateway_fee : 0);
    const differenceNetAmount = (totalSummary ? totalSummary.total_net_amount : 0) - (totalSummary ? totalSummary.main_total_net_amount : 0);
    const differenceMPGatewayFees = (totalSummary ? totalSummary.total_mp_gateway_fee : 0) - (totalSummary ? totalSummary.total_gateway_fee : 0);

    const widgetsData = [
        {
            value: totalRow,
            label: "Total Records",
        },
        {
            value: formatter.format(totalSummary ? totalSummary.total_gross_amount : 0),
            label: "Total Payments",
            isShowSubValue: currency && currency !== BASE_CURRENCY,
            subValue: formatterCurrency((totalSummary ? totalSummary.total_cur_gross_amount : 0), currency),
        },
        {
            value: formatter.format(totalSummary ? totalSummary.total_chargeback : 0),
            label: "Total Chargebacks",
            isShowSubValue: currency && currency !== BASE_CURRENCY,
            subValue: formatterCurrency((totalSummary ? totalSummary.total_chargeback : 0), currency),
        },
        {
            value: formatter.format(totalSummary ? totalSummary.total_commission : 0),
            label: "Total Commissions",
            isShowSubValue: currency && currency !== BASE_CURRENCY,
            subValue: formatterCurrency((totalSummary ? totalSummary.total_cur_commission : 0), currency),
        },
        {
            value: formatter.format(totalSummary ? totalSummary.total_gateway_fee : 0),
            label: "Total Gateway Fees",
            isShowSubValue: currency && currency !== BASE_CURRENCY,
            subValue: formatterCurrency((totalSummary ? totalSummary.total_cur_gateway_fee : 0), currency),
            isShowDifference: differenceGatewayFees !== 0,
            differenceValue: formatter.format(differenceGatewayFees),
        },
        {
            ...(differenceNetAmount === 0 ? {textColorClass: 'text-success'} : {}),
            value: formatter.format(totalSummary ? totalSummary.total_net_amount : 0),
            label: "Total Net Payments",
            isShowSubValue: currency && currency !== BASE_CURRENCY,
            subValue: formatterCurrency((totalSummary ? totalSummary.total_cur_net_amount : 0), currency),
            isShowDifference: differenceNetAmount !== 0,
            differenceValue: formatter.format(differenceNetAmount),
        },
        {
            value: formatter.format((totalSummary ? totalSummary.total_mp_gateway_fee : 0)),
            label: "Total Gateway Fee (MP)",
            isShowSubValue: currency && currency !== BASE_CURRENCY,
            subValue: formatterCurrency((totalSummary ? totalSummary.total_cur_mp_gateway_fee : 0), currency),
            isShowDifference: differenceMPGatewayFees !== 0,
            differenceValue: formatter.format(differenceMPGatewayFees),
        },
    ];

    return (
        <div className="row">
            {widgetsData.map((widget, index) => (
                <Widget
                    key={index}
                    textColorClass={widget.textColorClass}
                    value={widget.value}
                    label={widget.label}
                    isShowSubValue={widget.isShowSubValue}
                    subValue={widget.subValue}
                    isShowDifference={widget.isShowDifference}
                    differenceValue={widget.differenceValue}
                />
            ))}
        </div>
    );
};

export default PaymentsTotalSummary;
